// Color interpolation for C/R ratio
// < 0.65: green (aquamarine), 0.85: orange, > 0.95: red
export function getCRRatioColor(ratio: number): string {
  const green = { r: 45, g: 226, b: 191 };   // #2DE2BF Aquamarine
  const orange = { r: 255, g: 107, b: 0 };   // #FF6B00 Pumpkin Orange
  const red = { r: 227, g: 24, b: 55 };      // #E31837 Crimson Red

  const lerp = (a: number, b: number, t: number) => Math.round(a + (b - a) * t);
  const toHex = (c: { r: number; g: number; b: number }) =>
    `#${c.r.toString(16).padStart(2, '0')}${c.g.toString(16).padStart(2, '0')}${c.b.toString(16).padStart(2, '0')}`;

  if (ratio < 0.65) {
    return toHex(green);
  } else if (ratio < 0.85) {
    const t = (ratio - 0.65) / (0.85 - 0.65);
    return toHex({
      r: lerp(green.r, orange.r, t),
      g: lerp(green.g, orange.g, t),
      b: lerp(green.b, orange.b, t),
    });
  } else if (ratio < 0.95) {
    const t = (ratio - 0.85) / (0.95 - 0.85);
    return toHex({
      r: lerp(orange.r, red.r, t),
      g: lerp(orange.g, red.g, t),
      b: lerp(orange.b, red.b, t),
    });
  } else {
    return toHex(red);
  }
}
